import StyledTextFieldWithTitle from "@/modules/common/components/input/styled-text-field-with-title";
import { Typography } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";

export interface PriceDetailsCashFormProps {
  form: UseFormReturn<any>;
  namePrefix?: string;
}
export default function PriceDetailsCash({
  form: { control },
  namePrefix,
}: PriceDetailsCashFormProps) {
  const fieldName = (field: string) =>
    namePrefix ? `${namePrefix}.${field}` : field;
  return (
    <>
      <Controller
        control={control}
        name={fieldName("price")}
        render={({ field, fieldState }) => (
          <StyledTextFieldWithTitle
            {...field}
            formatNumeric
            title="Total Price"
            placeholder="Total Price"
            fullWidth
            size="small"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            slotProps={{
              input: {
                endAdornment: <Typography>EGP</Typography>,
              },
            }}
          />
        )}
      ></Controller>
    </>
  );
}
